import { v4 as uuidv4 } from "uuid";

const etcModule = {
  getDeviceToken: () => {
    let deviceToken = localStorage.getItem("DEVICE_TOKEN");
    if (!deviceToken) {
      deviceToken = uuidv4();
      localStorage.setItem("DEVICE_TOKEN", deviceToken);
    }

    return deviceToken;
  },

  toViewableDateFormat: (d) => {
    const date = new Date(d);

    let dd = date.getDate();
    let MM = date.getMonth();
    let yyyy = date.getFullYear();

    if (isNaN(dd)) dd = 0;
    if (isNaN(MM)) MM = 0;
    if (isNaN(yyyy)) yyyy = "0000";

    yyyy = yyyy.toString();

    return `${etcModule.shortMonths[MM]} ${dd}, ${yyyy}`;
  },

  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  sleep: (ms) => {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(true);
      }, ms)
    );
  },

  formatNumber: (number) => {
    if (number < 1000) return number.toString();

    const suffixes = ["", "Thousand", "Lakh", "Crore", "Thousand Crore"];
    const breakpoints = [1, 1000, 100000, 10000000, 10000000000]; // Corresponding breakpoints

    let i;
    for (i = breakpoints.length - 1; i >= 0; i--) {
      if (number >= breakpoints[i]) break;
    }

    const formattedNumber = (number / breakpoints[i])
      .toFixed(2)
      .replace(/\.00$/, ""); // Remove decimals if .00
    return `${formattedNumber} ${suffixes[i]}`;
  },
};

export default etcModule;
